import { Api } from "../config/request";

export default {
  getUploadUrl(payload) {
    return Api.post("/walker/bulk/onboarding/upload_info", payload);
  },
  // getPoiList(queryParams) {
  //   return Api.get(`/poi/list${queryParams && queryParams.length > 0 ? `?${queryParams}` : ""
  //     }`);
  // },
  getPoiDetail(payload) {
    const id = payload.id;
    return Api.get(`/poi/${id}`);
  },
  getWalkerList(poiId) {
    return Api.get(`/walker/list${poiId ? `?poi_id=${poiId}` : ""}`);
  },
};
